import {
    Signer,
    PSBTOptions,
    ToSignInput
} from "@cat-protocol/cat-sdk";
interface Window {
    safnectwallet: any
}

declare const window: Window & typeof globalThis;

type HexString = string;

export interface SafnectAPI {
    requestAccounts: () => Promise<{
        success: boolean
        msg: string
        code: number,
        data: any,
    }>
    signPsbt(psbtHex: HexString, options?: PSBTOptions): Promise<{
        code: number;
        success: boolean;
        msg: string;
        sign: string;
    }>;
    signPsbts(input: {
        psbts: string[];
        toSignInputs: Array<ToSignInput[]>;
    }): Promise<{
        code: number;
        success: boolean;
        msg: string;
        sign: string[];
    }>;
}

export class SafnectSigner implements Signer {
    private _api: SafnectAPI;

    constructor() {
        this._api = window.safnectwallet.fractalBitcoin
    }

    getSafnectwalletAPI(): SafnectAPI {
        const okx = this._api || window.safnectwallet.fractalBitcoin;
        if (typeof okx === 'undefined') {
            throw new Error('safnectwallet not install!');
        }

        return okx;
    }

    async getAddress(): Promise<string> {
        const results = await this.getSafnectwalletAPI().requestAccounts();
        if (results.success === false) {
            throw new Error(results.msg);
        }

        return results.data.address
    }

    async getPublicKey(): Promise<string> {
        const results = await this.getSafnectwalletAPI().requestAccounts();
        if (results.success === false) {
            throw new Error(results.msg);
        }

        return results.data.publicKey
    }

    async signPsbt(psbtHex: string, options?: PSBTOptions): Promise<string> {
        return this.getSafnectwalletAPI().signPsbt(psbtHex).then(res => {

            if (res.success === false) {
                return Promise.reject(new Error(res.msg));
            }
            console.log("signPsbts res", res);
            return res.sign;

        })
    }

    async signPsbts(
        reqs: { psbtHex: string; options?: PSBTOptions }[],
    ): Promise<string[]> {

        const options = {
            psbts: reqs.map(req => req.psbtHex),
            toSignInputs: reqs.map(req => req.options!.toSignInputs),
        }
        console.log("signPsbts", options);
        const res = await this.getSafnectwalletAPI().signPsbts(options);
        console.log("signPsbts res", res);

        if (res.success === false) {
            return Promise.reject(new Error(res.msg));
        }
        return res.sign;
    }
}
